<template>
  <generic-container
    icon="robot"
    :title="$t('automations')"
    :configurable="true"
    :show_plus="true"
    @add="add"
    :show_refresh="true"
    @refresh="init"
    :header_buttons="header_buttons"
    @configure="configure"
  >
    <table
      class="ui blue very compact celled striped selectable table"
      ref="table"
      style="width: 100%"
    >
      <thead>
        <tr>
          <th>{{ $t("name") }}</th>
          <th>{{ $t("group") }}</th>
          <th>{{ $t("engine") }}</th>
          <th>{{ $t("automator") }}</th>
          <!-- <th>{{ $t("price") }}</th> -->
          <th>{{ $t("options") }}</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
    <automation-modal ref="automation_modal" @success="init" />
    <task-modal ref="task_modal" />
    <configure-modal ref="configure_modal" />
    <!-- <payment-modal ref="payment_modal" />
    <plan-modal ref="plan_modal" /> -->
  </generic-container>
</template>

<script>
import filters from "@/filters";
import {
  // local_api,
  init_ajax_data_datables,
  enterprise_setup,
  // error_toast,
  register_listener,
} from "@/utils";
import GenericContainer from "@/components/GenericContainer";
import ConfigureModal from "./configuration_modal/Index.vue";
import AutomationModal from "./automation_modal/Index.vue";
import TaskModal from "./task_modal/Index.vue";
// import PaymentModal from "./payment_modal/Index.vue";
// import PlanModal from "./plan_modal/Index.vue";

// @ is an alias to /src
export default {
  name: "AutomationIndex",
  components: {
    "generic-container": GenericContainer,
    AutomationModal,
    ConfigureModal,
    TaskModal,
    // PaymentModal,
    // PlanModal,
  },
  filters: filters,
  data() {
    return {
      datatable: {},
      header_buttons: [
        // {
        //   icon: "cubes",
        //   click: this.go_bulk,
        //   tooltip: this.$t("bulk process"),
        // },
      ],
    };
  },
  computed: {
    enterprise_setup() {
      return enterprise_setup(this);
    },
  },
  methods: {
    add() {
      let vm = this;
      vm.$refs.automation_modal.show_modal();
    },
    configure() {
      let vm = this;
      vm.$refs.configure_modal.show_modal();
    },
    init() {
      let vm = this;
      let columns = [
        {
          data: function (row) {
            return row.name;
          },
        },
        {
          data: function (row) {
            return row.automation_group ? row.automation_group.name : "";
          },
        },
        {
          data: function (row) {
            return row.engine;
          },
        },
        {
          data: function (row) {
            return row.automator;
          },
        },

        // {
        //   data: function (row) {
        //     return filters.formatCurrency(
        //       row.price,
        //       vm.enterprise_setup.currency_iso,
        //     );
        //   },
        // },
        {
          data: function (row) {
            return `<div class="ui tiny basic icon button" data-tooltip="${vm.$t(
              "edit",
            )}" onclick="window.dispatchEvent(new CustomEvent('edit_automation', {'detail':'${
              row.uuid
            }'}))"><i class="edit orange icon"></i></div>
              <div class="ui tiny basic icon button" data-tooltip="${vm.$t(
                "create automation",
              )}" onclick="window.dispatchEvent(new CustomEvent('create_task', {'detail':'${
              row.uuid
            }'}))"><i class="plus green icon"></i></div>
              <div class="ui tiny basic icon button" data-tooltip="${vm.$t(
                "task list",
              )}" onclick="window.dispatchEvent(new CustomEvent('list_tasks', {'detail':'${
              row.uuid
            }'}))"><i class="list blue icon"></i></div>`;
          },
        },
        // {
        //   data: function(row) {
        //     return "<pre>" + JSON.stringify(row, null, 2) + "</pre>";
        //   },
        // },
      ];
      let onSelect = (/* data */) => {
        // vm.$refs.project_modal.show_modal(data);
      };
      vm.datatable = init_ajax_data_datables(
        vm,
        vm.$refs.table,
        window.jQuery.fn.api.settings.api["automation url"],
        columns,
        onSelect,
      );
      vm.register_listeners();
    },
    get_table_data() {
      let vm = this;
      let data = vm.datatable.data();
      // console.log("data", data.length, data);
      let r = [];
      data.each((element) => {
        r.push(element);
      });
      return r;
    },
    register_listeners() {
      let vm = this;
      register_listener("edit_automation", (event) => {
        event.stopImmediatePropagation();
        let uuid = event.detail;
        let tabledata = vm.get_table_data();
        let trgt = tabledata.find((el) => {
          return el.uuid == uuid;
        });
        if (trgt) vm.$refs.automation_modal.show_modal(trgt);
      });

      register_listener("create_task", (event) => {
        event.stopImmediatePropagation();
        let uuid = event.detail;
        let tabledata = vm.get_table_data();
        let trgt = tabledata.find((el) => {
          return el.uuid == uuid;
        });
        vm.$refs.task_modal.show_modal({ automation_id: trgt.automation_id });
      });

      register_listener("list_tasks", (event) => {
        event.stopImmediatePropagation();
        let uuid = event.detail;
        vm.$router.push({
          name: "AutomationTasks",
          query: { i: uuid },
        });
        // vm.$refs.plan_modal.show_modal(uuid);
      });
    },
  },
  created() {},
  mounted() {
    let vm = this;
    vm.init();

    // vm.register_listeners()
  },
  watch: {},
};
</script>
